// Product type that matches Supabase schema
export interface ProductUsages {
  winter: number;
  spring: number;
  summer: number;
  fall: number;
  day: number;
  night: number;
}

export interface Product {
  id: string;
  name: string;
  nameArabic: string;
  price: number;
  category: string;
  categories: string[];
  image: string;
  images: string[];
  sizes: { label: string; price: number }[];
  story: string;
  notes: {
    top: string[];
    middle: string[];
    base: string[];
  };
  ingredients: string[];
  inStock: boolean;
  isBestSeller: boolean;
  usages: ProductUsages;
}

// Transform database product to frontend Product type
export const transformProduct = (dbProduct: any): Product => {
  const sizes = Array.isArray(dbProduct.sizes)
    ? dbProduct.sizes.map((s: any) => ({
        label: s.label || "",
        price: s.price || 0,
      }))
    : [{ label: "50ml EDP", price: dbProduct.price }];

  const notes =
    dbProduct.notes && typeof dbProduct.notes === "object" && !Array.isArray(dbProduct.notes)
      ? (dbProduct.notes as { top: string[]; middle: string[]; base: string[] })
      : { top: [], middle: [], base: [] };

  const images = Array.isArray(dbProduct.images) && dbProduct.images.length > 0
    ? dbProduct.images
    : dbProduct.image_url
    ? [dbProduct.image_url]
    : ["/placeholder.svg"];

  const defaultUsages = { winter: 0, spring: 0, summer: 0, fall: 0, day: 0, night: 0 };
  const usages = dbProduct.usages && typeof dbProduct.usages === "object"
    ? { ...defaultUsages, ...dbProduct.usages }
    : defaultUsages;

  const productCategories = Array.isArray(dbProduct.categories) && dbProduct.categories.length > 0
    ? dbProduct.categories
    : [dbProduct.category];

  return {
    id: dbProduct.id,
    name: dbProduct.name,
    nameArabic: dbProduct.name_arabic || "",
    price: dbProduct.price,
    category: dbProduct.category,
    categories: productCategories,
    image: dbProduct.image_url || images[0] || "/placeholder.svg",
    images,
    sizes,
    story: dbProduct.story || "",
    notes,
    ingredients: dbProduct.ingredients || [],
    inStock: dbProduct.in_stock ?? true,
    isBestSeller: dbProduct.is_best_seller ?? false,
    usages,
  };
};
